import * as React from "react";
import {Store} from "../../project/reducer";
import {Dispatch} from "../../../../shared/ts/interfaces/dispatch";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import * as _ from "lodash";

import Main from "../../shared/layout/Main";
import Content from "../../project/components/content/Content";
import ContentHeader from "../../project/components/content/ContentHeader";
import ContentHeaderTitle from "../../project/components/content/ContentHeaderTitle";
import ContentBody from "../../project/components/content/ContentBody";
import {Panel, PanelBody} from "../../shared/panel/Panel";
import {HocSort, sort} from "../../../../shared/ts/decorators/sort";
import {fetch, HocFetch} from "../../../../shared/ts/decorators/fetch";
import {HocPagination, pagination} from "../../../../shared/ts/decorators/pagination";
import {PAGE_PARAM, SORT_PARAM} from "../../../../shared/ts/constants/queryParams";
import {Pagination} from "../../shared/pagination/Pagination";
import {Dictionary} from "../../../../shared/ts/interfaces/structure";
import {AppError, RequestState} from "../../../../shared/ts/helpers/util";
import {PaginationState} from "../../../../shared/ts/helpers/pagination";
import CenterBox from "../../shared/layout/CenterBox";
import Icon from "../../shared/icon/Icon";
import Loader from "../../shared/loader/Loader";
import ContextPanel from "../../context_panel/components/ContextPanel";
import {tagsOfferListContextPanelActions} from "../../context_panel/reducers/context_panel";
import {closePanel, openPanel, openTab} from "../../context_panel/actions/context_panel";
import ContextPanelBody from "../../context_panel/components/ContextPanelBody";
import {TabsContent} from "../../../../shared/ts/components/tabs/TabsContent";
import {toFormData} from "../../shared/form/translate/to_form_data";
import {FormActions} from "../../../../shared/ts/helpers/create_form_actions";
import {fromFormData} from "../../shared/form/translate/from_form_data";
import {fetchTagsOfferList, ITagsOffer, resetTagsOfferList} from "../actions/fetch_tags_offer_list";
import {offerTagsListFormFields, TagsOfferListFilterForm} from "../components/TagsOfferListFilterForm";
import {offerTagsListFormActions} from "../actions/offer_tags_list_form";
import {TagsOfferList} from "../components/TagsOfferList";
import {TagsOfferListContextPanelHeader} from "../components/TagsOfferListContextPanelHeader";


interface IStateProps {
    offers: ITagsOffer[];
    request: RequestState;
    pagination: PaginationState;
    contextPanelOpened: boolean;
    openedTabIndex: number;
    errors: AppError | null;
    formValues: Record<keyof typeof offerTagsListFormFields, any>;
}
interface IActionProps {
    formActions: FormActions;
    actions: {
        fetchTagsOfferList: typeof fetchTagsOfferList;
        resetTagsOfferList: typeof resetTagsOfferList;
        openPanel: typeof openPanel;
        closePanel: typeof closePanel;
        openTab: typeof openTab;
    };
}

interface HocSortProps {
    hoc: HocFetch & HocPagination & HocSort;
}

interface IProps extends IStateProps, IActionProps, HocSortProps {}

interface IState {}


const defaultPage = 1;
const defaultSort = "";

@pagination(PAGE_PARAM)
@sort(SORT_PARAM)
@fetch((state: Store) => state.tags.offerList, fetchActions, validateQuery)
@connect(mapStateToProps, mapActionsToProps)
export class OfferTagsListView extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {open: false};
    }

    private onSortChange = (column: string): void => {
        this.props.hoc.sort.toggle(column, this.props.hoc.pagination.get());
    };

    private onContextPanelTabOpen = (tabId: number): void => {
        this.props.actions.openTab(tagsOfferListContextPanelActions.openTab, tabId);
        this.props.actions.openPanel(tagsOfferListContextPanelActions.openPanel);
    };

    private onContextPanelToggle = (): void => {
        if (this.props.contextPanelOpened) {
            this.props.actions.closePanel(tagsOfferListContextPanelActions.closePanel);
        } else {
            this.props.actions.openPanel(tagsOfferListContextPanelActions.openPanel);
        }
    };

    private onSubmit = (e: React.FormEvent<HTMLElement>) => {
        e.preventDefault();
        this.props.hoc.fetch.reset(toFormData(offerTagsListFormFields, this.props.formValues));
    };

    private onReset = () => this.props.hoc.fetch.reset(toFormData(offerTagsListFormFields, {}));

    private renderList = (request: boolean) => (
        <Panel color="default" className="psr mb-xl">
            <PanelBody>
                <TagsOfferList
                    offers={this.props.offers}
                    onSort={this.onSortChange}
                    sortName={this.props.hoc.sort.getName()}
                    sortDirection={this.props.hoc.sort.getDirection()}
                    loading={request}
                />
            </PanelBody>
        </Panel>
    );

    private renderEmptyList = () => {
        return (
            <ContentBody className="df fg-1">
                <CenterBox>
                    <Icon icon="empty-list" className="empty-list-icon" />
                    <div className="tac fs30">Nic tu nie ma, zmień parametry szukania</div>
                </CenterBox>
            </ContentBody>
        );
    };

    private renderError = () => {
        return (
            <CenterBox>
                <Icon icon="empty-list" className="empty-list-icon" />
                <div className="error-message tac fs30">Popraw błędne parametry szukania</div>
            </CenterBox>
        );
    };

    private renderLoader = () => {
        return (
            <CenterBox className="vhc">
                <Loader size="lg" />
            </CenterBox>
        );
    };

    private renderContent = () => {
        const {request, offers} = this.props;

        if (request === RequestState.Success && _.isEmpty(offers)) {
            return this.renderEmptyList();
        }

        if (request === RequestState.Success || (request === RequestState.Waiting && !_.isEmpty(offers))) {
            return this.renderList(request === RequestState.Waiting);
        }

        if (request === RequestState.Error) {
            return this.renderError();
        }

        return this.renderLoader();
    };

    public render() {

        const {hoc, request, errors} = this.props;

        return (
            <Main>
                <Content>
                    <ContentHeader>
                        <ContentHeaderTitle>
                            Tagi inwestycji
                        </ContentHeaderTitle>
                    </ContentHeader>

                    <ContentBody>
                        {this.renderContent()}

                        <div className="pagination-holder tac pss b-0">
                            <Pagination
                                totalCount={this.props.pagination.total}
                                pageSize={this.props.pagination.pageSize}
                                activePage={hoc.pagination.currentPage()}
                                onPageChange={hoc.pagination.set}
                            />
                        </div>
                    </ContentBody>
                </Content>

                <ContextPanel opened={this.props.contextPanelOpened}>
                    <TagsOfferListContextPanelHeader
                        opened={this.props.contextPanelOpened}
                        openedTabIndex={this.props.openedTabIndex}
                        onTabOpen={this.onContextPanelTabOpen}
                        onPanelToggle={this.onContextPanelToggle}
                    />

                    <ContextPanelBody className="filters-holder">
                        <TabsContent openedTabIndex={this.props.openedTabIndex}>
                            <TagsOfferListFilterForm
                                values={this.props.formValues}
                                errors={errors && errors.fieldErrors}
                                onChange={this.props.formActions.update}
                                onSubmit={this.onSubmit}
                                onReset={this.onReset}
                                request={request}
                            />
                        </TabsContent>
                    </ContextPanelBody>
                </ContextPanel>
            </Main>
        );
    }
}

/**
 * Connect
 */
function mapStateToProps(store: Store): IStateProps {
    return {
        offers: store.tags.offerList.offers,
        request: store.tags.offerList.requestState,
        pagination: store.tags.offerList.pagination,
        contextPanelOpened: store.tags.offerList.contextPanel.opened,
        openedTabIndex: store.tags.offerList.contextPanel.openedTabIndex,
        errors: store.tags.offerList.errors,
        formValues: store.tags.offerListFormValues
    };
}
function mapActionsToProps(dispatch: Dispatch): IActionProps {
    return {
        formActions: bindActionCreators(offerTagsListFormActions, dispatch),
        actions: bindActionCreators({
            fetchTagsOfferList,
            resetTagsOfferList,
            openPanel,
            closePanel,
            openTab
        }, dispatch)
    };
}

/**
 * Fetch
 */
function fetchActions(dispatch: Dispatch, query: Dictionary<string>): void {
    dispatch(offerTagsListFormActions.replace(fromFormData(offerTagsListFormFields, _.omit(query, [PAGE_PARAM, SORT_PARAM]))));
    dispatch(fetchTagsOfferList(query));
}
function validateQuery(query: Dictionary<string>): Dictionary<string> {
    return {
        [PAGE_PARAM]: query[PAGE_PARAM] || defaultPage.toString(),
        [SORT_PARAM]: query[SORT_PARAM] || defaultSort
    };
}
